import { styled } from "@mui/material/styles";
import { Box, Link } from "designSystem/index";
import session from "csi/session";
import { isLocalUser, isPortalUser } from "csi/sessionConstants";
import { sessionStore } from "csi/state/rootStore";
import React, { FunctionComponent } from "react";

const PREFIX = "HeaderCentricIcon";

const classes = {
	root: `${PREFIX}root`,
};

const StyledLink = styled(Link)((
	{
		theme,
	},
) => ({
	[`& .${classes.root}`]: {
		backgroundImage: "var(--CompanyLogoImageURL)",
		width: 37,
		height: 37,
	},
}));

interface HeaderCentricIconProps {
}

export const HeaderCentricIcon: FunctionComponent<HeaderCentricIconProps> = (props) => {
	const params = {};

	if (!isPortalUser) {
		params[session.LOCATION_TAB] = isLocalUser ? "SupplierUserHome" : "MyHome";
	}
	const url = session.getLocationForUrl(sessionStore.homeUrl, params);

	return <StyledLink href={url}><Box className={classes.root} {...props} /></StyledLink>;
};

export default HeaderCentricIcon;

